import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { clientContent } from '../../client/content';
import Section from '../../components/Section';
import styles from './Concepts.module.scss';
import electricianImg from '../../assets/images/electrician-concept.webp';
import counsellorImg from '../../assets/images/consultant.webp';
import lawImg from '../../assets/images/law-firm-concept.webp';

const Concepts: React.FC = () => {
  const { title, description, canonical } = clientContent.seo.concepts;
  const { title: pageTitle, subtitle, notice, items, supporting } = clientContent.concepts;

  return (
    <div className={styles.concepts} data-testid="concepts-page">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
      </Helmet>

      {/* Hero Section */}
      <section className="pageHeader">
        <div className="container">
          <span className="eyebrow">Website Concepts</span>
          <h1>{pageTitle}</h1>
          <p>{subtitle}</p>
          <div className={styles.noticeBanner}>
            <p>{notice}</p>
          </div>
        </div>
      </section>

      {/* Concepts Showcase Section */}
      <Section background="surface">
        <div className={styles.showcaseGrid}>
          {items.map((item) => (
            <a 
              key={item.id} 
              href={item.demoUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.conceptCardLink}
            >
              <div className={styles.conceptCard}>
                <div className={styles.previewArea}>
                  <img 
                    src={item.id === 'electrician' ? electricianImg : item.id === 'counsellor' ? counsellorImg : lawImg} 
                    alt={item.title} 
                    className={styles.conceptImg}
                  />
                  <div className={styles.previewOverlay}>
                    <span className={styles.categoryBadge}>{item.category}</span>
                    <h3 className={styles.previewTitle}>{item.title}</h3>
                  </div>
                </div>
                <div className={styles.contentArea}>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <span className={styles.viewConceptCta}>
                    View Concept →
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </Section>

      {/* Supporting Section */}
      <Section background="default">
        <div className={styles.supportingSection}>
          <h2>{supporting.heading}</h2>
          <p>{supporting.description}</p>
          <div className={styles.supportingCtaWrapper}>
            <Link to={supporting.ctaPath} className={styles.supportingCtaButton}>
              {supporting.ctaLabel}
            </Link>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Concepts;
